import { useEffect, useState } from 'react';

const getRelativeDate = (daysAgo: number): string => {
  const d = new Date();
  d.setDate(d.getDate() - daysAgo);
  return d.toISOString().slice(0, 10);
};

const quoteBase = [
  { daysAgo: 0, name: '김OO님', phone: '010-62OO-OOOO', type: '포장이사', area: '서울' },
  { daysAgo: 0, name: '김OO님', phone: '010-57OO-OOOO', type: '포장이사', area: '서울' },
  { daysAgo: 0, name: '송OO님', phone: '010-57OO-OOOO', type: '포장이사', area: '경기' },
  { daysAgo: 0, name: '진OO님', phone: '010-58OO-OOOO', type: '청소서비스', area: '인천' },
  { daysAgo: 1, name: '김OO님', phone: '010-94OO-OOOO', type: '포장이사', area: '서울' },
  { daysAgo: 1, name: '주OO님', phone: '010-66OO-OOOO', type: '원룸이사', area: '서울' },
  { daysAgo: 1, name: '이OO님', phone: '010-85OO-OOOO', type: '포장이사', area: '경남' },
  { daysAgo: 2, name: '진OO님', phone: '010-58OO-OOOO', type: '포장이사', area: '인천' },
  { daysAgo: 2, name: '배OO님', phone: '010-54OO-OOOO', type: '원룸이사', area: '부산' },
  { daysAgo: 2, name: '강OO님', phone: '010-32OO-OOOO', type: '포장이사', area: '경기' },
];

const PAGE_SIZE = 6;

const mockQuotes = quoteBase.map((q, i) => ({
  id: i,
  date: getRelativeDate(q.daysAgo),
  name: q.name,
  phone: q.phone,
  type: q.type,
  area: q.area,
  status: '신규접수',
}));

const getPage = (startIndex: number) => {
  const result = [];
  for (let i = 0; i < PAGE_SIZE; i++) {
    result.push(mockQuotes[(startIndex + i) % mockQuotes.length]);
  }
  return result;
};

export default function QuoteList() {
  const [startIndex, setStartIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setStartIndex((prev) => (prev + 1) % mockQuotes.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  const visibleQuotes = getPage(startIndex);

  return (
    <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
      {/* 헤더 - 모바일은 3열, 데스크탑은 6열 */}
      <div className="bg-teal-600 text-white px-4 py-3 text-xs font-semibold">
        {/* 모바일 헤더 */}
        <div className="grid grid-cols-3 gap-2 md:hidden">
          <div>고객명</div>
          <div>신청항목</div>
          <div>지역</div>
        </div>
        {/* 데스크탑 헤더 */}
        <div className="hidden md:grid md:grid-cols-6 gap-2">
          <div>접수일</div>
          <div>고객명</div>
          <div className="col-span-2">전화번호</div>
          <div>신청항목</div>
          <div>지역</div>
        </div>
      </div>

      <div className="divide-y divide-gray-100">
        {visibleQuotes.map((quote) => (
          <div
            key={quote.id}
            className="px-4 py-3 text-xs text-gray-700 hover:bg-gray-50 transition-colors"
          >
            {/* 모바일 행 */}
            <div className="grid grid-cols-3 gap-2 md:hidden">
              <div className="font-medium">{quote.name}</div>
              <div className="text-teal-600">{quote.type}</div>
              <div>{quote.area}</div>
            </div>
            {/* 데스크탑 행 */}
            <div className="hidden md:grid md:grid-cols-6 gap-2">
              <div className="text-gray-500">{quote.date}</div>
              <div>{quote.name}</div>
              <div className="col-span-2 text-gray-500">{quote.phone}</div>
              <div className="text-teal-600">{quote.type}</div>
              <div>{quote.area}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
